import { z } from 'zod';

export const ZodUserBirthdate = z.string().refine((str) => /^\d{4}-\d{2}-\d{2}/.test(str), {
  message: 'must be valid date string',
});
